import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getDeliveryZones = ({
  page,
  pageSize,
  search = '',
  orderBy,
  orderDirection,
}) =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: '/deliveryzone/list',
    data: {
      page,
      pageSize,
      search,
      orderBy,
      orderDirection,
    },
  });
